import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tip, TipUsageContent, Typography } from '@dev/ee-components';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { OpenUpsellingOverlay } from '@/store/templateEditor/actions';
import { AvailableFeaturesUpselling } from '@dev/ee-modules';
import { SavedModulesLimitInfoProps } from "./SavedModulesLimitInfoInterface";
import { useSavedLimits } from '../../hooks/useSavedLimits';

const SavedModulesLimitWrapper = styled.div`
    display: flex;
    align-items: center;
    padding-left: 16px;
    padding-top: 24px;
`;

const TipWrapper = styled.div`
    margin-left: 8px;
`;

export const SavedModulesLimitInfo = ({
    zIndex 
}: SavedModulesLimitInfoProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isSaveUpgradeable, savedLimit, savedRemaining, savedCount } = useSavedLimits();

    const onUpgradeClick = (): void => {
        dispatch(OpenUpsellingOverlay(AvailableFeaturesUpselling.SavedModules));
    };

    const upgradeInfo = [
        {
            text: t('wanttoincreaseyourlimit'),
            linkText: t('upgradeformore'),
            linkOnClick: onUpgradeClick,
        }
    ]
    
    return (
        <SavedModulesLimitWrapper>
            <Typography variant="h4">{t('savedmodulesremaining', { count: savedRemaining })}</Typography>
            <TipWrapper>
                <Tip id="saved-modules-remaining-tip" zIndex={zIndex}>
                    <TipUsageContent 
                        title={t('savedmodulesusage')}
                        usageCount={savedCount}
                        usageLimit={savedLimit}
                        usageRemaining={savedRemaining}
                        id="savedListCount"
                        additionalInfo={isSaveUpgradeable && upgradeInfo}
                    />
                </Tip>
            </TipWrapper>
        </SavedModulesLimitWrapper>
    );
};
